<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="app" :class="vueAppClasses" @mouseup="mouseUp" @dblclick="dblClick">
        <Template></Template>
    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import Template from "@/layouts/Template";
import axios from "@/axios";
import events from "@/events/events";
import {story} from "@/class/story";

export default {
    components: {Template},
    data() {
        return {
            vueAppClasses: []
        }
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val)
        },
        '$vs.rtl'(val) {
            document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
        }
    },
    methods: {
        mouseUp(){
            events.$emit("body:click:mouse:up")
        },
        dblClick(){
            events.$emit("body:click:dblclick")
        },
        keyDown(e){
            // if (e.keyCode === 83 && e.ctrlKey) {
            //     e.preventDefault();
            //     events.$emit("interactive-image:keydown:save")
            // }
            if ((e.keyCode === 89 && e.ctrlKey) || (e.keyCode === 90 && e.ctrlKey && e.shiftKey)) {
                e.preventDefault();
                return events.$emit("body:keydown:redo")
            }
            if (e.keyCode === 90 && e.ctrlKey) {
                e.preventDefault();
                return events.$emit("body:keydown:undo")
            }
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                return events.$emit("body:keydown:switch-tab")
            }
            if (e.keyCode === 27) {
                e.preventDefault();
                return events.$emit("body:keydown:escape")
            }
        },
        toggleClassInBody(className) {
            if (className === 'dark') {
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
                document.body.classList.add('theme-dark')
            } else if (className === 'semi-dark') {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                document.body.classList.add('theme-semi-dark')
            } else {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
            }
        },
        setAppClasses(classesStr) {
            this.vueAppClasses.push(classesStr)
        },
        handleWindowResize() {
            this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
            
            // Set --vh property
            document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
        },
        handleScroll() {
            this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
        }
    },
    mounted() {
        this.toggleClassInBody(themeConfig.theme)
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
        
        const vh = window.innerHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    
        window.addEventListener("keydown", this.keyDown);
    },
    destroyed() {
        window.removeEventListener("keydown", this.keyDown);
    },
    async created() {
        const dir = this.$vs.rtl ? 'rtl' : 'ltr'
        document.documentElement.setAttribute('dir', dir)

        // axios.interceptors.response.use(undefined, (err) => {
        //     return new Promise((resolve, reject) => {
        //         return;
        //         if (!err.status || err.status === 401) {
        //             // if you ever get an unauthorized, logout the user
        //             this.$store.dispatch("AUTH_LOGOUT")
        //             // you can also redirect to /login if needed !
        //
        //             this.$router.push('/')
        //         }
        //         // throw err;
        //     });
        // });
    
        // document.addEventListener("dragstart", function( event ) {
        //     var img = new Image();
        //     img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
        //     event.dataTransfer.setDragImage(img, 0, 0);
        // }, false);
        
    },
}

</script>
